import React, { useState, useMemo } from 'react';
import BlockUi from 'react-block-ui';
import { useDispatch, useSelector } from 'react-redux';
import { Container, ListGroup, ListGroupItem, Row } from 'reactstrap';
import { Accordion, AccordionTab } from 'primereact/accordion';
//
// import Modal from '../../components/Modal';
import ProjectForm from './project-form';
import TaskForm, { AddTaskForm } from './task-form';
import PulseLoader from 'react-spinners/PulseLoader';
import team from '../../services/team';
import { isEmpty } from 'lodash';
import firebase from '../../config/firebase.config';
import { useHistory } from 'react-router-dom';
import { teamActionTypes } from '@store/Team/Team.actionTypes';
import { useTeamMemberDetailsForSelect } from '../../hooks/useTeamMemberDetailsForSelect';
import classNames from 'classnames';
import styles from './Projects.module.scss';
import { SvgIcon } from '@/components/SvgIcon';
import { SvgIconSrc } from '@/components/SvgIcon/SvgIcon.constants';
import { Button } from '@/components/Button';
import { buttonVariants } from '@/components/Button/Button.constants';
import { ModalComponent } from '@/components/Modal/Modal.component';
import { ProjectFormModal } from './ProjectFormModal.component';
const database = firebase.firestore();

export const ProjectComponent = () => {
  const history = useHistory();
  const teams = useSelector((state) => ({
    teams: state.team.teams,
    loadingProject: state.team.loadingProject,
    activeTeam: state.team.activeTeam,
    selectedTeamId: state.team.selectedTeamID,
    projects: state.team.projects,
    tasks: state.team.tasks,
    activeUserId: state.team.activeUserID,
    all: state.team.all,
    loading: false,
    selectedProject: state.team.selectedProject,
    active: state.team.active,
  }));
  const auth = useSelector((state) => ({ ...state.auth }));
  const activeTeamId = teams.active?.activeTeamid ?? null;
  const { memberDetails } = useTeamMemberDetailsForSelect(activeTeamId);
  const members = useMemo(() => {
    if (!memberDetails || typeof memberDetails !== 'object') return [];
    return Object.entries(memberDetails)
      .map(([uid, m]) => ({
        userUID: uid,
        userName: m?.userName || m?.userEmailid || uid,
      }))
      .filter((m) => m.userUID)
      .sort((a, b) => (a.userName || '').localeCompare(b.userName || ''));
  }, [memberDetails]);
  const dispatch = useDispatch();
  const [state, setState] = useState({
    defaultProjectIdx: 0,
    modal: '',
    selectedProjectId: '',
  });

  const { activeCompany } = useSelector((state) => state.auth.profile);
  const [list, setList] = useState([]);

  React.useEffect(() => {
    if (!isEmpty(teams.active))
      dispatch({
        type: teamActionTypes.GET_PROJECT,
        payload: { companyId: activeCompany.companyId },
      });
  }, [teams.selectedTeamId]);

  React.useEffect(() => {
    if (!isEmpty(teams.active)) {
      dispatch({
        type: teamActionTypes.GET_TASKS,
        payload: {
          projectId: teams.selectedProject,
          teamId: teams.active.activeTeamid,
          activeUserId: auth?.profile?.id,
        },
      });
    }
  }, [teams.active]);

  const handleCloseEventModal = () => {
    setState({ ...state, modal: '', selectedProjectId: '' });
  };

  const getTasksList = (projectId) => {
    dispatch({
      type: teamActionTypes.GET_TASKS,
      payload: {
        companyId: activeCompany.companyId,
        projectId: projectId,
        teamId: teams.active.activeTeamid,
        activeUserId: teams.activeUserId,
      },
    });
  };

  const editProject = (project) => {
    setState({ ...state, project, modal: 'PROJECT-FORM' });
  };

  const deleteProject = (project) => {
    dispatch({
      type: teamActionTypes.DELETE_PROJECT,
      payload: {
        ...project,
        teamId: teams.active.activeTeamid,
        companyId: { companyId: activeCompany.companyId },
      },
    });
  };

  React.useEffect(() => {
    if (!teams.loading) {
      handleCloseEventModal();
    }
  }, [teams.loading]);

  const getTasksNames = async () => {
    if (!isEmpty(teams?.projects)) {
      for (let i = 0; i < (teams?.projects).length; i++) {
        if (
          teams?.projects[i]?.data?.taskList &&
          (teams?.projects[i]?.data?.taskList).length > 0
        ) {
          for (
            let j = 0;
            j < (teams?.projects[i]?.data?.taskList).length;
            j++
          ) {
            const data = await database
              .collection('taskDatabase')
              .doc(teams?.projects[i]?.data?.taskList[j])
              .get();

            list.push({
              id: teams?.projects[i]?.data?.taskList[j],
              title: data?.data()?.Title,
            });
          }
        }
      }
    }
    setList(
      list.filter((v, i, a) => a.findIndex((v2) => v2.title === v.title) === i)
    );
  };

  React.useEffect(() => {
    getTasksNames();
  }, [teams?.projects]);
  return (
    <div
      className="header pb-md-2  pt-md-2"
      style={{ paddingTop: '5rem!important' }}
    >
      <ModalComponent
        isVisible={state.modal === 'PROJECT-FORM'}
        onClose={handleCloseEventModal}
      >
        <ProjectFormModal
          project={state.project}
          onClose={handleCloseEventModal}
        />
      </ModalComponent>
      {/* <Modal
        isOpen={state.modal === 'TASK-FORM'}
        size={'sm'}
        onClose={handleCloseEventModal}
        title="Add Task"
      >
        <div style={{ padding: '20px' }}>
          <TaskForm
            project={state.project}
            projects={teams.projects}
            handleCloseEventModal={handleCloseEventModal}
            members={members}
          />
        </div>
      </Modal> */}
      <Container className="pt-md-0" fluid>
        <BlockUi tag="div" blocking={teams.loading}>
          <Row>
            <div className="col-12 p-3">
              {isEmpty(auth?.profile?.companyList) ? (
                <div className="shadow p-3 card">
                  <h4 className="text-danger">
                    Please create a company first to create a project!
                  </h4>
                </div>
              ) : (
                <div className="shadow p-3 card">
                  {teams.loadingProject ? (
                    <div className="time-track-section">
                      <PulseLoader color="#4f58bb" />
                    </div>
                  ) : (
                    <div
                      className={styles.buttonsContainer}
                      style={{ margin: '10px 0px' }}
                    >
                      <Button
                        text="Add Task"
                        variant={buttonVariants.primary}
                        onClick={() => history.push('/add-task')}
                      />
                      <Button
                        text="Add Project"
                        variant={buttonVariants.secondary}
                        onClick={() => {
                          setState({
                            ...state,
                            modal: 'PROJECT-FORM',
                            project: null,
                          });
                        }}
                      />
                    </div>
                  )}
                  <Accordion multiple activeIndex={0}>
                    {teams?.projects?.length > 0 &&
                      teams?.projects?.map(
                        (res, index) =>
                          !res.data.deleted && (
                            <AccordionTab
                              className={classNames(styles.accordion)}
                              header={
                                <>
                                  <div
                                    className={classNames('title btn-title')}
                                  >
                                    <span>{res.data.project_name}</span>
                                  </div>
                                  <div
                                    className={styles.actionsContainer}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}
                                  >
                                    <SvgIcon
                                      src={SvgIconSrc.edit}
                                      size={16}
                                      onClick={() =>
                                        editProject({ projectId: res?.id })
                                      }
                                    />
                                    <SvgIcon
                                      src={SvgIconSrc.delete}
                                      size={16}
                                      onClick={() =>
                                        deleteProject({
                                          projectId: res?.id,
                                        })
                                      }
                                    />
                                  </div>
                                </>
                              }
                            >
                              <ListGroup>
                                {res?.data?.taskList?.length > 0 ? (
                                  res?.data?.taskList?.map((res, index) => (
                                    <>
                                      <ListGroupItem
                                        key={res}
                                        active={teams.selectedProject === res}
                                        tag="button"
                                        action
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                        }}
                                        size="sm"
                                      >
                                        <div
                                          onClick={() => {
                                            getTasksList(res, index);
                                          }}
                                        >
                                          {
                                            (list?.filter((a) => {
                                              if (a.id == res) {
                                                return a;
                                              }
                                            }))[0]?.title
                                          }
                                        </div>
                                      </ListGroupItem>
                                    </>
                                  ))
                                ) : (
                                  <div>No Tasks Created Yet</div>
                                )}
                              </ListGroup>
                            </AccordionTab>
                          )
                      )}
                  </Accordion>
                </div>
              )}
            </div>
          </Row>
          {/* <Modal
            isOpen={state.modal === 'PROJECT-FORM'}
            size={'sm'}
            onClose={handleCloseEventModal}
            title="Add Project"
          >
            <div style={{ padding: '20px' }}>
              <ProjectForm
                project={state.project}
                handleCloseEventModal={handleCloseEventModal}
              />
            </div>
          </Modal> */}
        </BlockUi>
      </Container>
    </div>
  );
};
